/* Layout */
import Layout from '../../views/layout/Layout.vue'

const BrandList = () => import(/* webpackChunkName: "brand-list" */ '@/views/brand/brand-list')
const BrandDetail = () => import(/* webpackChunkName: "brand-detail" */ '@/views/brand/brand-detail')

export default [
  {
    path: '/brand',
    component: Layout,
    redirect: '/brand/list',
    name: 'brand',
    alwaysShow: true,
    meta: {
      title: 'brand',
      icon: 'archive',
    },
    children: [
      {
        path: 'create',
        component: BrandDetail,
        props: true,
        name: 'brandCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'brand',
        },
      },
      {
        path: 'list',
        component: BrandList,
        name: 'BrandList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'brand',
        },
      },
      {
        path: 'edit/:id',
        component: BrandDetail,
        props: true,
        name: 'brandEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'brand',
        },
      },
    ],
  },
]
